import React from 'react'
import Grid from '../../../../components/Grid'
import HseLogo from '../HseLogo'
import { EPathSegment } from '../../../../utils'
import Icon, { EIconId } from '../../../../components/icons'

const UserBar: React.FC<{
  onMenuClick: () => void
  isLoggedIn: boolean
  cartCount: number
}> = (props) => {
  const loginOrAccountId = props.isLoggedIn ? 'my_account' : 'login'
  return (
    <div className="py-12 sm:pt-12 md:pb-12">
      <Grid.Container>
        <Grid.Row className="items-center relative">
          <Grid.Col
            id="navigation_menu"
            className="flex-initial flex flex-col items-center order-1 md:mr-16 lg:hidden"
            onClick={props.onMenuClick}
          >
            <Icon id={EIconId.MENU} className="w-24 select-none pointer-events-none cursor-pointer sm:w-32" />
            <span className="uif-text-10 select-none pointer-events-none xs:text-12">Menü</span>
          </Grid.Col>
          <Grid.Col className="absolute top-0 -translate-x-1/2 mt-4" style={{ left: '50%' }}>
            <HseLogo />
          </Grid.Col>
          <Grid.Col className="order-last flex-none min-w-full" />
          <Grid.Col
            id={loginOrAccountId}
            className="flex-initial ml-auto flex flex-col items-center order-3 mr-4 sm:mr-12"
            href={props.isLoggedIn ? EPathSegment.ACCOUNT : `${EPathSegment.ACCOUNT}/login`}
          >
            {props.isLoggedIn ? (
              <>
                <Icon id={EIconId.LOGGED_IN} className="w-24 pointer-events-none sm:w-32" />
                <span className="uif-text-10 pointer-events-none xs:text-12">Mein Konto</span>
              </>
            ) : (
              <>
                <Icon id={EIconId.LOGGED_OUT} className="w-24 pointer-events-none sm:w-32" />
                <span className="uif-text-10 pointer-events-none xs:text-12">Einloggen</span>
              </>
            )}
          </Grid.Col>
          <Grid.Col
            id="basket"
            className="flex-initial flex flex-col items-center relative order-4"
            href={EPathSegment.CHECKOUT}
          >
            <Icon id={EIconId.BAG} className="w-24 pointer-events-none sm:w-32" />
            {props.cartCount > 0 && (
              <span className="flex justify-center items-center w-20 h-20 absolute top-0 right-0 rounded-full text-14 text-white font-bold bg-brand-orange pointer-events-none">
                {props.cartCount}
              </span>
            )}
            <span className="uif-text-10 pointer-events-none xs:text-12">Warenkorb</span>
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>
    </div>
  )
}

export default UserBar
